// Where a sign-in may send the user afterwards. Only a same-site absolute
// path: one leading "/" not followed by another "/" or a "\" (browsers read
// "//host" and "/\host" as another origin), and no whitespace or control
// characters anywhere (the URL parser deletes tabs and newlines, so "/\t/host"
// would become "//host"). Anything else, including "https://..." and
// "javascript:...", falls back.
const SAME_SITE_PATH = /^\/(?![/\\])/;
const UNSAFE_CHARS = /[\s\u0000-\u001F\u007F]/;

export function safeRedirect(raw, fallback) {
  if (typeof raw !== "string" || !SAME_SITE_PATH.test(raw) || UNSAFE_CHARS.test(raw)) return fallback;
  return raw;
}
